import React, { Component } from "react";
import PubSub from 'pubsub-js'
import AreaManagePage from "./areaManagePage/areaManagePage";
import ControlPage from "./controlPage/controlPage";
import CreateBuildPage from "./createBuildPage/createBuildPage";
import CreateAreaPage from "./createAreaPage/createAreaPage";
import CreateGroupPage from "./createGroupPage/createGroupPage";
import SelectBuildPage from "./selectBuildPage/selectBuildPage";
import SelectAreaPage from "./selectAreaPage/selectAreaPage";
import SensorSetting from "./controlPage/sensorSet/sensorSetting/sensorSetting";
import SensorDevice from "./controlPage/sensorSet/sensorDevice/sensorDevice";
import SensorDeviceControl from "./controlPage/sensorSet/sensorDevice/sensorDeviceControl/sensorDeviceControl";
import EmergencySetDevice from "./controlPage/emergencySet/emergencySetDevice/emergencySetDevice";
import EmergencySetDeviceControl from "./controlPage/emergencySet/emergencySetDevice/emergencySetDeviceControl/emergencySetDeviceControl";
import EmergencyLightingDevice from "./controlPage/emergencyLighting/emergencyLightingDevice/emergencyLightingDevice";
import EmergencyLightingDeviceControl from "./controlPage/emergencyLighting/emergencyLightingDevice/emergencyLightingDeviceControl/emergencyLightingDeviceControl";

import DesignView from "../admin/designView/designView";
import { meshLog } from "../../utils/spUtils";
import { AREA_create_build, AREA_create_area, AREA_create_group, AREA_click_group, AREA_select_build, AREA_select_area } from "../../const/infoConst";
import './areaSet.less';


export default class AreaSet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showControlPage: 'hidden', //'visible'
      showBuildPage: 'none', //'visible'
      showAreaPage: 'none', //'visible'
      showGroupPage: 'none', //'visible'
      showSelectBuild: 'none', //'visible'
      showSelectArea: 'none', //'visible'
      sensorSetting: 'hidden', //'visible'
      sensorDevice: 'hidden', //'visible'
      sensorDeviceControl: 'hidden', //'visible'
      emergencySetDevice: 'hidden', //'visible'
      emergencySetDeviceControl: 'hidden',
      emergencyLightingDevice: 'hidden', //'visible'
      emergencyLightingDeviceControl: 'hidden',

    };
  }

  componentDidMount() {
    PubSub.subscribe('changeMeshUpdateUI', (msg, data) => {
      this.setState({
        showBuildPage: 'none',
      });
    })

    PubSub.unsubscribe("gotoSensrorSettings")
    PubSub.subscribe('gotoSensrorSettings', (msg, data) => {
      this.setState({
        sensorSetting: 'visible',
        showControlPage: 'hidden',
      });
    })

    PubSub.unsubscribe("gotoSensorset")
    PubSub.subscribe('gotoSensorset', (msg, data) => {
      this.setState({
        sensorSetting: 'hidden',
        sensorDevice: 'hidden',
        emergencySetDevice: 'hidden',
        emergencyLightingDevice: 'hidden',
        showControlPage: 'visible',
      });
    })

    PubSub.unsubscribe("gotoSensorDevice")
    PubSub.subscribe('gotoSensorDevice', (msg, data) => {
      this.setState({
        sensorDevice: 'visible',
        showControlPage: 'hidden',
        sensorDeviceControl: 'hidden',
        emergencySetDeviceControl: 'hidden',
        emergencyLightingDeviceControl: 'hidden',
      });
    })
    PubSub.unsubscribe("gotoEmergencySetDevice")
    PubSub.subscribe('gotoEmergencySetDevice', (msg, data) => {
      this.setState({
        emergencySetDevice: 'visible',
        showControlPage: 'hidden',
      });
    })

    PubSub.unsubscribe("gotoEmergencyLightingDevice")
    PubSub.subscribe('gotoEmergencyLightingDevice', (msg, data) => {
      this.setState({
        emergencyLightingDevice: 'visible',
        showControlPage: 'hidden',
      });
    })

    PubSub.unsubscribe("gotoSensorDeviceControl")
    PubSub.subscribe('gotoSensorDeviceControl', (msg, data) => {
      this.setState({
        sensorDeviceControl: 'visible',
        sensorDevice: 'hidden',
      });
    })

    PubSub.unsubscribe("gotoEmergencySetDeviceControl")
    PubSub.subscribe('gotoEmergencySetDeviceControl', (msg, data) => {
      this.setState({
        emergencySetDeviceControl: 'visible',
        sensorDevice: 'hidden',
      });
    })

    PubSub.unsubscribe("gotoEmergencyLightingDeviceControl")
    PubSub.subscribe('gotoEmergencyLightingDeviceControl', (msg, data) => {
      this.setState({
        emergencyLightingDeviceControl: 'visible',
        sensorDevice: 'hidden',
      });
    })





  }

  getDataFromManage = (msg) => {
    meshLog('Manage', msg);
    this.setState({
      showControlPage: 'hidden',
      showBuildPage: 'none',
      showAreaPage: 'none',
      showGroupPage: 'none',
      showSelectBuild: 'none',
      showSelectArea: 'none',
    })
    if (msg == AREA_create_build) {
      meshLog('Manage 1');
      this.setState({
        showBuildPage: 'flex',
      })
    } else if (msg == AREA_create_area) {
      meshLog('Manage 2');
      this.setState({
        showAreaPage: 'flex',
      })
    } else if (msg == AREA_create_group) {
      meshLog('Manage 3');
      this.setState({
        showGroupPage: 'flex',
      })
    } else if (msg == AREA_click_group) {
      meshLog('Manage 4');
      this.setState({
        showControlPage: 'visible',
      })
    } else if (msg == AREA_select_build) {
      meshLog('Manage 5');
      this.setState({
        showSelectBuild: 'flex',
      })
    } else if (msg == AREA_select_area) {
      meshLog('Manage 6');
      this.setState({
        showSelectArea: 'flex',
      })
    }
  }

  getDataFromControl = (msg) => {
    meshLog('Control', msg);
    this.setState({
      showControlPage: 'hidden',
    });
  }

  getDataFromBuild = (msg) => {
    meshLog('Build', msg);
    this.setState({
      showBuildPage: 'none',
    });
  }

  getDataFromArea = (msg) => {
    meshLog('Area', msg);
    this.setState({
      showAreaPage: 'none',
    });
  }

  getDataFromGroup = (msg) => {
    meshLog('Group', msg);
    this.setState({
      showGroupPage: 'none',
    });
  }

  getDataFromBulidList = (msg) => {
    meshLog('BulidList', msg);
    this.setState({
      showSelectBuild: 'none',
    });
    if (msg == AREA_create_build) { //编辑build
      this.setState({
        showBuildPage: 'flex',
      })
    }
  }

  getDataFromAreaList = (msg) => {
    meshLog('AreaList', msg);
    this.setState({
      showSelectArea: 'none',
    });
    if (msg == AREA_create_area) { //编辑area
      this.setState({
        showAreaPage: 'flex',
      })
    }
  }

  getDataFromControl = (msg) => {
    meshLog('Control', msg);
    this.setState({
      showControlPage: 'hidden',
    });
  }


  render() {


    return (
      <div className="area-container">
        {/* 左边侧边栏 */}
        <div className="sidebar1"><AreaManagePage onDataToParent={this.getDataFromManage} /></div>

        {/* 右边平面图 */}
        <div className="content">
          <div className="bg-image" ><DesignView /></div>
        </div>

        <div className="sidebar3" style={{ display: this.state.showBuildPage }}><CreateBuildPage onDataToParent={this.getDataFromBuild} /></div>
        <div className="sidebar3" style={{ display: this.state.showAreaPage }}><CreateAreaPage onDataToParent={this.getDataFromArea} /></div>
        <div className="sidebar3" style={{ display: this.state.showGroupPage }}><CreateGroupPage onDataToParent={this.getDataFromGroup} /></div>
        <div className="sidebar3" style={{ display: this.state.showSelectBuild }}><SelectBuildPage onDataToParent={this.getDataFromBulidList} /></div>
        <div className="sidebar3" style={{ display: this.state.showSelectArea }}><SelectAreaPage onDataToParent={this.getDataFromAreaList} /></div>

        <div className="sidebar3" style={{ visibility: this.state.sensorSetting }}><SensorSetting /></div>
        <div className="sidebar3" style={{ visibility: this.state.sensorDevice }}><SensorDevice /></div>
        <div className="sidebar3" style={{ visibility: this.state.sensorDeviceControl }}><SensorDeviceControl /></div>
        <div className="sidebar3" style={{ visibility: this.state.emergencySetDevice }}><EmergencySetDevice /></div>
        <div className="sidebar3" style={{ visibility: this.state.emergencySetDeviceControl }}><EmergencySetDeviceControl /></div>
        <div className="sidebar3" style={{ visibility: this.state.emergencyLightingDevice }}><EmergencyLightingDevice /></div>
        <div className="sidebar3" style={{ visibility: this.state.emergencyLightingDeviceControl }}><EmergencyLightingDeviceControl /></div>
        <div className="sidebar3" style={{ visibility: this.state.showControlPage }}><ControlPage onDataToParent={this.getDataFromControl} /></div>
      </div>
    );
  }
}
